'use strict';

var define = require('define-properties');
var implementation = require('./implementation');
var getPolyfill = require('./polyfill');
var polyfill = getPolyfill();
var shim = require('./shim');
var boundContains = function contains(node, other) {
  return polyfill.apply(node, [other]);
};
define(boundContains, {
  getPolyfill: getPolyfill,
  implementation: implementation,
  shim: shim
});
module.exports = boundContains;